// extracted by mini-css-extract-plugin
export default {"playerContainer":"VideoPlayerDialog_playerContainer__gbZvr","video":"VideoPlayerDialog_video__zBmX-","loadingState":"VideoPlayerDialog_loadingState__eucUa"};